import React from 'react';
import { createComponent } from '@lit-labs/react';

import Dsy from './dsyui';

const LitComp = Dsy.components.DsyInputWithMessage;

export const DsyInputWithMessage = createComponent(
  React,
  'dsy-input-with-message',
  LitComp,
  {},
);

export default DsyInputWithMessage;
